import { products } from '@/mocks/products';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function ProductsSection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollReveal();
  const { ref: cardsRef, isVisible: cardsVisible } = useScrollReveal();

  return (
    <section id="our-products" className="bg-nv-surface py-20 md:py-28 lg:py-32">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div
            ref={headerRef}
            className={`mb-12 md:mb-16 transition-all duration-700 ${
              headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <span className="text-nv-muted text-sm tracking-widest uppercase mb-4 block">
              Our Products
            </span>
            <h2 className="font-serif text-nv-black text-3xl md:text-4xl lg:text-5xl font-medium leading-tight">
              Ready-made Solutions
              <span className="text-nv-muted block mt-1">for Your Business</span>
            </h2>
          </div>

          <div
            ref={cardsRef}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6"
          >
            {products.map((product, index) => (
              <div
                key={product.id}
                className={`bg-white rounded-2xl overflow-hidden group hover:-translate-y-2 transition-all duration-500 ${
                  cardsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
                }`}
                style={{ transitionDelay: cardsVisible ? `${index * 150}ms` : '0ms' }}
              >
                <div className="w-full h-52 md:h-60 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6 md:p-7">
                  <h3 className="text-nv-black text-lg font-semibold mb-2">
                    {product.name}
                  </h3>
                  <p className="text-nv-muted text-sm leading-relaxed">
                    {product.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
